dmx.Component('oauth2', {

  attributes: {
    'flow': {
      type: String,
      default: 'PKCE' // 'Authorization Code', 'PKCE', 'Implicit', 'Password'
    },

    'authorize-uri': {
      type: String,
      default: ''
    },

    'token-uri': {
      type: String,
      default: ''
    },

    'redirect-uri': {
      type: String,
      default: ''
    },

    'client-id': {
      type: String,
      default: ''
    },

    'scope': {
      type: String,
      default: ''
    },

    'username': {
      type: String,
      default: ''
    },

    'password': {
      type: String,
      default: ''
    }
  },

  methods: {
    authorize: function() {
      this.authorize();
    }
  },

  render: function() {
    if (window.location.search) {
      var params = new URLSearchParams(location.search.slice(1));

      if (params.get('code')) {
        var code = params.get('code');
        var state = params.get('state');

        if (state == sessionStorage.getItem('oauth2-state')) {
          this.getToken(code);
        } else {
          this.set('error', 'Invalid state');
        }
      } else if (params.get('error')) {
        this.set('error', params.get('error_description'));
      }
    }

    if (window.location.hash) {
      var params = new URLSearchParams(location.hash.slice(1));

      if (params.get('access_token')) {
        if (state == sessionStorage.getItem('oauth2-state')) {
          this.set('token', {
            access_token: params.get('access_token'),
            token_type: params.get('token_type'),
            expires_in: params.get('expires_in'),
            scope: params.get('scope')
          });
        } else {
          this.set('error', 'Invalid state');
        }
      }
    }
  },

  authorize: function() {
    if (this.props.flow == 'PKCE') {
      var code_verifier = dmx.oauth2.generate_code_verifier();
      var code_challenge = dmx.oauth2.generate_code_challenge(code_verifier);
      var state = dmx.oauth2.generate_state();

      // store code_verifier and state
      sessionStorage.setItem('oauth2-code-verifier', code_verifier);
      sessionStorage.setItem('oauth2-state', state);

      // redirect
      this.redirect(this.props['authorize-uri'], {
        response_type: 'code',
        client_id: this.props['client-id'],
        redirect_uri: this.getRedirectURI(),
        scope: this.props.scope,
        state: state,
        code_challenge: code_challenge,
        code_challenge_method: 'S256'
      });
    } else if (this.props.flow == 'Authorization Code' || this.props.flow == 'Implicit') {
      var state = dmx.oauth2.generate_state();

      // store state
      sessionStorage.setItem('oauth2-state', state);

      // redirect
      this.redirect(this.props['authorize-uri'], {
        response_type: 'code',
        client_id: this.props['client-id'],
        redirect_uri: this.getRedirectURI(),
        scope: this.props.scope,
        state: state
      });
    } else if (this.props.flow == 'Password') {
      var params = {
        grant_type: 'password',
        client_id: this.props['client-id'],
        username: this.props.username,
        password: this.props.password
      };

      this.post(this.props['token-uri'], params);
    }
  },

  getToken: function(code) {
    var params = {
      grant_type: 'authorization_code',
      client_id: this.props['client-id'],
      redirect_uri: this.getRedirectURI(),
      code: code
    };

    if (this.props.flow == 'PKCE') {
      params.code_verifier = sessionStorage.getItem('oauth2-code-verifier');
    }

    this.post(this.props['token-uri'], params);
  },

  getRedirectURI: function() {
    var redirect_uri = this.props['redirect-uri'];

    if (!redirect_uri) {
      redirect_uri = location.href.replace(/\?.*$/, '').replace(/#.*$/, '');
    }

    return redirect_uri;
  },

  post: function(uri, params) {
    var xhr = new XMLHttpRequest();
    xhr.addEventListener('load', (function() {
      this.set('token', JSON.parse(xhr.responseText));
    }).bind(this));
    xhr.open('POST', uri);
    xhr.send(this.queryString(params));
  },

  redirect: function(uri, params) {
    window.location.assign(uri + '?' + this.queryString(params));
  },

  queryString: function(params) {
    return Object.keys(params).map(function(key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
  }

});
